import { Box, Skeleton } from '@mui/material';
import React from 'react';

import { DATA_TEST } from '../NavBar/enums';

const SkeletonRow = () => (
  <Skeleton data-test={DATA_TEST.loading_block_indicator} variant="rounded" width="100%" height={32} />
);

export const LoadingSkeleton = () => {
  return (
    <Box display="flex" flexDirection="column" gap={1} px={1}>
      <SkeletonRow />
      <SkeletonRow />
      <SkeletonRow />
    </Box>
  );
};
